// extracted by mini-css-extract-plugin
export default {"container":"hawk-display-name-container","full":"hawk-display-name-full"};